var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFooterdots(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 79,
    height: 46,
    viewBox: "0 0 79 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.8609 0.857297V8.5791M7.7218 4.7182H0H7.7218Z",
    stroke: "#2972D7",
    strokeWidth: 0.593985,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.8609 19.8646V27.5864M7.7218 23.7255H0H7.7218Z",
    stroke: "#2972D7",
    strokeWidth: 0.593985,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.8609 38.2782V46M7.7218 42.1391H0H7.7218Z",
    stroke: "#2972D7",
    strokeWidth: 0.593985,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.8609 0.857297V8.5791M7.7218 4.7182H0H7.7218Z",
    stroke: "#2972D7",
    strokeWidth: 1.18797,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.8609 19.8646V27.5864M7.7218 23.7255H0H7.7218Z",
    stroke: "#2972D7",
    strokeWidth: 1.18797,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3.8609 38.2782V46M7.7218 42.1391H0H7.7218Z",
    stroke: "#2972D7",
    strokeWidth: 1.18797,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6802 0.857297V8.5791M25.5411 4.7182H17.8193H25.5411Z",
    stroke: "#2972D7",
    strokeWidth: 0.593985,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6802 19.8646V27.5864M25.5411 23.7255H17.8193H25.5411Z",
    stroke: "#2972D7",
    strokeWidth: 0.593985,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6802 38.2782V46M25.5411 42.1391H17.8193H25.5411Z",
    stroke: "#2972D7",
    strokeWidth: 0.593985,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6802 0.857297V8.5791M25.5411 4.7182H17.8193H25.5411Z",
    stroke: "#2972D7",
    strokeWidth: 1.18797,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6802 19.8646V27.5864M25.5411 23.7255H17.8193H25.5411Z",
    stroke: "#2972D7",
    strokeWidth: 1.18797,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6802 38.2782V46M25.5411 42.1391H17.8193H25.5411Z",
    stroke: "#2972D7",
    strokeWidth: 1.18797,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M39.4996 19.8646V27.5864M43.3605 23.7255H35.6387H43.3605Z",
    stroke: "#2972D7",
    strokeWidth: 0.593985,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M39.4996 38.2782V46M43.3605 42.1391H35.6387H43.3605Z",
    stroke: "#2972D7",
    strokeWidth: 0.593985,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M39.4996 19.8646V27.5864M43.3605 23.7255H35.6387H43.3605Z",
    stroke: "#2972D7",
    strokeWidth: 1.18797,
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M39.4996 38.2782V46M43.3605 42.1391H35.6387H43.3605Z",
    stroke: "#2972D7",
    strokeWidth: 1.18797,
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M57.3199 19.8646V27.5864M61.1808 23.7255H53.459H61.1808Z",
    stroke: "#2972D7",
    strokeWidth: 0.593985,
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M57.3199 38.2782V46M61.1808 42.1391H53.459H61.1808Z",
    stroke: "#2972D7",
    strokeWidth: 0.593985,
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M57.3199 19.8646V27.5864M61.1808 23.7255H53.459H61.1808Z",
    stroke: "#2972D7",
    strokeWidth: 1.18797,
    strokeMiterlimit: 10
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M57.3199 38.2782V46M61.1808 42.1391H53.459H61.1808Z",
    stroke: "#2972D7",
    strokeWidth: 1.18797,
    strokeMiterlimit: 10
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M75.1392 19.8646V27.5864M79.0001 23.7255H71.2783H79.0001Z",
    stroke: "#2972D7",
    strokeWidth: 0.593985,
    strokeMiterlimit: 10
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M75.1392 38.2782V46M79.0001 42.1391H71.2783H79.0001Z",
    stroke: "#2972D7",
    strokeWidth: 0.593985,
    strokeMiterlimit: 10
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M75.1392 19.8646V27.5864M79.0001 23.7255H71.2783H79.0001Z",
    stroke: "#2972D7",
    strokeWidth: 1.18797,
    strokeMiterlimit: 10
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M75.1392 38.2782V46M79.0001 42.1391H71.2783H79.0001Z",
    stroke: "#2972D7",
    strokeWidth: 1.18797,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterdots);
export default __webpack_public_path__ + "static/media/footerdots.695f98301e6cfbc5cc47ed97311add20.svg";
export { ForwardRef as ReactComponent };